<template>
    <footer class="footer-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <router-link to="/" class="logo">
                            <img :src="getImgUrl('resimler', image.image_image)" alt="logo" v-for="image of images"
                                :key="image.image_id">
                        </router-link>
                        <p v-for="title of titles" :key="title.title_id">{{ title.title_content }}</p>
                        <ul class="social-link">
                            <li>
                                <a href="https://facebook.com/" class="d-block" target="_blank">
                                    <i class='bx bxl-facebook'></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://twitter.com/" class="d-block" target="_blank">
                                    <i class='bx bxl-twitter'></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://instagram.com/" class="d-block" target="_blank">
                                    <i class='bx bxl-instagram'></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://linkedin.com/" class="d-block" target="_blank">
                                    <i class='bx bxl-linkedin'></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-6">
                    <div class="single-footer-widget pl-5">
                        <h3>Keşfet</h3>
                        <ul class="footer-links-list">
                            <li><router-link to="/">Ana Sayfa</router-link></li>
                            <li><router-link to="/siniflarimiz">Sınıflar</router-link></li>
                            <li><router-link to="/kurslarimiz">Kurslarımız</router-link></li>
                            <li><router-link to="/etkinliklerimiz">Etkinlikler</router-link></li>
                            <li><router-link to="/bloglar">Blog Yazılarımız</router-link></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h3>Hakkımızda</h3>
                        <ul class="footer-links-list">
                            <li><router-link to="/iletisim">İletişim</router-link></li>
                            <li><router-link to="/hakkimizda">Hakkımızda</router-link></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h3>Adres</h3>
                        <ul class="footer-contact-info">

                            <li v-for="contactInfo of contactInfos" :key="contactInfo.contact_id">
                                <i class='bx bx-map'></i>
                                {{ contactInfo.contact_content }}
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="footer-bottom-area">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-6">
                        <p><i class='bx bx-copyright'></i>{{ currentYear }} bütün hakları saklıdır <a target="_blank"
                                href="https://envytheme.com/"> DRY Yazılım </a></p>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <ul>
                            <li>
                                <router-link to="/privacy-policy"></router-link>
                            </li>
                            <li>
                                <router-link to="/terms-of-service"></router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="lines">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
        </div>
    </footer>
</template>

<script>

import axios from "axios";


export default {
    name: 'Footer',

    created() {
        this.getTitles();
        this.getImages();
        this.getContactInfo();
    },
    data() {
        return {
            titles: [],
            images: [],
            contactInfos: [],
            errors: [],
            currentYear: new Date().getFullYear(),
            pathUrl: 'https://dryyazilim.com.tr/anaokulu/assets/data/get.php'
        };
    },
    methods: {
        getTitles() {
            axios.get(this.pathUrl + "?data=title&parent=13")
                .then(response => (this.titles = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getContactInfo() {
            axios.get(this.pathUrl + "?data=contactInfo")
                .then(response => (this.contactInfos = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getImages() {
            axios.get(this.pathUrl + "?data=image&parent=11")
                .then(response => (this.images = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/' + category + '/' + pet)
        }
    }
}
</script>